var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "关联品牌管理",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "100px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "已关联品牌" } },
                [
                  _vm.pram && _vm.pram.brandList && _vm.pram.brandList.length
                    ? _vm._l(_vm.pram.brandList, function (item, i) {
                        return _c(
                          "el-tag",
                          {
                            key: i,
                            staticStyle: { "margin-right": "15px" },
                            attrs: { closable: "" },
                            on: {
                              close: function ($event) {
                                return _vm.removeBrand(i)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item))]
                        )
                      })
                    : _c("div", [_vm._v("暂无关联")]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "添加品牌", prop: "interfaceTemplate" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: "请选择",
                        filterable: "",
                        "filter-method": _vm.handleAgreementSearch,
                      },
                      model: {
                        value: _vm.pram.brandList,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "brandList", $$v)
                        },
                        expression: "pram.brandList",
                      },
                    },
                    _vm._l(_vm.brandOption, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.brandStr, value: item.brandStr },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }